module.exports = __webpack_public_path__ + "static/media/nrl-logo.929a7839.svg";